import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_CODEBOX_GET_LIST } from 'api/actionTypes';

export default async function getCodeboxList({ state, apiClient }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_CODEBOX_GET_LIST,
    state: state,
    onSuccess(codeboxList) {
      typeCheck('codeboxList::Array', codeboxList);
      state.set(['codebox', 'list'], codeboxList);
      return codeboxList;
    },
  });
}
